<script setup lang="ts"></script>

<template>
  <div class="store-no-search-results">
    <p class="store-no-search-results__title">{{ $t('store_page.no_search_result.title') }}</p>
    <p class="store-no-search-results__text" v-html="$t('store_page.no_search_result.content')"></p>
  </div>
</template>
<style lang="postcss">
.store-no-search-results {
  margin-top: var(--space-50);
  p {
    margin-bottom: 0;
  }
  .store-no-search-results__title {
    text-align: center;
    padding: 1rem;
  }

  .store-no-search-results__text {
    color: var(--text-tertiary);
    border-radius: 0.25rem;
    border: 1px solid var(--border-disabled,);
    background: var(--surface-light-00,);
    padding: 1.5rem 1rem;
  }
}
</style>
